<template>

  <form v-on:submit="save" action="#" method="post" id="" v-if="user">

    <div class="row">
      <div class="col-xs-4">
        <div class="form-group">
          <label for="consultant" class="required">Supervisor</label>
          <v-select2 id="consultant" :options="supervisors" label="email" v-model="user.supervisor" :searchable="true">
            <template slot="option" slot-scope="option">
              <span><b>{{ option.firstname }} {{ option.lastname }}</b><br><small> {{ option.email }}</small></span>
            </template>
          </v-select2>
        </div>

      </div>
      <div class="col-xs-8" style="margin-top: 20px">
        <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info pull-right" :data-style="submit.dataStyle"> Save Changes </vue-ladda>
      </div>
    </div>
  </form>
</template>

<style scoped>

</style>
<script>

import vSelect2 from '../../components/utils/select2'
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda, vSelect2},
  name: 'Supervisor',
  props: ['user'],
  data () {
    return {
      supervisors: [],
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    save: function (e) {
      e.preventDefault()

      this.submit.loading = true

      this.axios.patch('user/' + this.user.id + '/supervisor', {
        intermediary_id: this.user.supervisor.id
      }).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Supervisor changed',
          placement: 'bottom-right'
        })
      }).finally(() => {
        this.submit.loading = false
      })
    },
    getResources: function () {
      this.axios.get('/user/' + this.user.id + '/supervisors')
        .then((response) => {
          this.supervisors = response.data
        })
        .catch(function (error) {
        })
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Supervisor.vue